import React, { useState, useRef, useEffect, useCallback } from 'react';

import {
  Box,
  Paper,
  TextField,
  Grid,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  styled,
  Divider,
  Typography,
  Button,
} from '@mui/material';

import { grey } from '@mui/material/colors';

import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { checkValueExists } from '../../../../../utils/dataSchema';
import CommonSectionHeader from '../../../../../components/common/CommonSectionHeader';
import CommonRestricted from '../../../../../components/common/CommonRestricted';

import { useAppContextFeatures } from '../../../../../context/AppContext';
import { useSystemPrompt } from '../../../../../hooks/useSystemPrompt';

import { useRegions, regionTypes } from '../../../../../hooks/api/useRegions';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../../hooks/usePermissions';
import { useTranslations } from '../../../../../hooks/useTranslations';

import {
  markingInjectionProps,
  branchDataTypes,
  validationSchema,
  initialValues,
  useMarking
} from "../../../hooks/model/useMarking"

import {
  customerInjectionProps,
  useCustomer
} from "../../../hooks/model/useCustomer"

const StyledCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export default function UpdateBranch({
  id,
  parentUserId,
  routeType,
  handleOnSuccess
}) {

  const { t } = useTranslations({ ns: ['common', '@user', '_prompt', '_common'] });

  const { promptMessage } = useSystemPrompt();

  const { getCustomer } = useCustomer({ routeType })
  const { getMarking, updateMarking, listMarkings } = useMarking({ routeType })

  const { isPermissionAllow } = usePermissions(
    routeType,
    scopeIds.userBranches.id,
    scopeTypes[scopeIds.userBranches.id].customer.id
  );
  const { setSystemLoading } = useAppContextFeatures();

  const [savedValues, setSavedValues] = useState();
  const { list: listRegions } = useRegions({});
  const [dataCountries, setDataCountries] = useState([]);
  const [dataStates, setDataStates] = useState([]);
  const [dataAreas, setDataAreas] = useState([]);

  const [dataMarkings, setDataMarkings] = useState([]);

  const loadData = async (id) => {
    setSystemLoading(true);

    try {

      const data = await getMarking({ id });
      const { branch } = data;

      setSavedValues({
        branchName: branch.branch_name,
        branchCode: branch.branch_code,
        branchContact: branch?.branch_contact ? branch.branch_contact : '',
        branchEmail: branch?.branch_email ? branch.branch_email : '',
        type: branch.type,
        address1: branch.address_1,
        address2: branch.address_2 ? branch.address_2 : '',
        countryId: branch.country_id,
        stateId: branch.state_id,
        areaId: branch.area_id,
        postcode: branch.postcode,
        picName: branch.pic_name ? branch.pic_name : '',
        picContact: branch.pic_contact ? branch.pic_contact : '',
        picEmail: branch.pic_email ? branch.pic_email : '',
        isHQ: branch?.is_hq === '1',
        status: branch?.status === '1',
        remark: branch.remark ? branch.remark : '',
        userId: branch.user_id,
        id: branch.id,
        marking: branch[markingInjectionProps.marking.retrieveKey],
        injectionProps: {
          [markingInjectionProps.marking.retrieveKey]: branch[markingInjectionProps.marking.retrieveKey],
          [markingInjectionProps.postcode.retrieveKey]: branch[markingInjectionProps.postcode.retrieveKey],
          [markingInjectionProps.sourceMarkingRemId.retrieveKey]:
            branch[markingInjectionProps.sourceMarkingRemId.retrieveKey],
        },
      });

    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }

    setSystemLoading(false);

  }

  const onSubmit = async (currentValues) => {
    try {

      let payload = {
        customerUserId: currentValues.userId,
        markingId: currentValues.id,
        marking: currentValues?.marking,
        branch: {
          branchName: currentValues?.branchName,
          branchCode: currentValues?.branchCode,
          branchContact: currentValues?.branchContact,
          branchEmail: currentValues?.branchEmail,
          type: currentValues?.type,
          address1: currentValues?.address1,
          address2: currentValues?.address2,
          countryId: currentValues?.countryId,
          stateId: currentValues?.stateId,
          areaId: currentValues?.areaId,
          postcode: currentValues?.postcode,
          remark: currentValues?.remark,
          picName: currentValues?.picName,
          picContact: currentValues?.picContact,
          picEmail: currentValues?.picEmail,
          isHq: currentValues?.isHQ,
          status: currentValues?.status,
        }
      }

      let response = await updateMarking(payload)

      promptMessage(true, `${response?.message}`);

      if (handleOnSuccess) handleOnSuccess();

    } catch (error) {
      promptMessage(false, `Action Failed. (${error?.message})`);
    }
  };

  const fetchCustomer = async ({ id }) => {
    try {

      // const data = await getCustomer({ id });

      const props = {
        limit: -1,
        skip: 0,
        sortInfo: {
          id: "id",
          dir: 0,
        },
        filterValue: [

        ],
      }

      const { data } = await listMarkings({
        props,
        customerUserId: id
      })

      // console.log('data', data)
      // const dataCustomer = data?.customer ? data.customer : {};

      let markings = [];

      markings = data.map(i => ({
        display: i[markingInjectionProps.marking.retrieveKey],
        value: i[markingInjectionProps.marking.retrieveKey],
      }))

      // if (dataCustomer?.injection_props) {

      //   dataCustomer.injection_props.forEach((i) => {
      //     if (i?.type.toLowerCase() === customerInjectionProps.marking.submitKey) {
      //       let a = i?.value ? JSON.parse(i?.value) : [];

      //       markings = a.map((i5) => {
      //         return {
      //           display: i5,
      //           value: i5,
      //         };
      //       });

      //       // markings.push({
      //       //     display: i?.value,
      //       //     value: i?.value
      //       // })
      //     }
      //   });
      // }

      console.log('markings', markings);

      setDataMarkings(markings);

    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }
  };

  const fetchDataCountry = async () => {
    try {
      const props = {
        limit: -1,
        offset: 0,
        filterValue: [],
        sortInfo: {
          id: 'country_name',
          dir: 0,
        },
      };

      props.regionType = regionTypes.country;

      const { data } = await listRegions(props);

      // console.log('re', data);

      setDataCountries(data?.countries);
    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }
  };

  const fetchDataStates = async (countryId) => {
    setDataStates([]);

    try {
      const props = {
        limit: -1,
        offset: 0,
        filterValue: [],
        sortInfo: {
          id: 'state_name',
          dir: 0,
        },
      };

      props.regionType = regionTypes.state;
      props.countryId = countryId;

      const { data } = await listRegions(props);

      setDataStates(data?.states);
    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }
  };

  const fetchDataAreas = async (stateId) => {
    setDataAreas([]);

    try {
      const props = {
        limit: -1,
        offset: 0,
        filterValue: [],
        sortInfo: {
          id: 'area_name',
          dir: 0,
        },
      };

      props.regionType = regionTypes.area;
      props.stateId = stateId;

      const { data } = await listRegions(props);

      setDataAreas(data?.areas);
    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }
  };

  const formik = useFormik({
    initialValues: savedValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit,
  });

  const { touched, values, errors, handleChange, handleSubmit, setFieldValue } = formik;

  useEffect(() => {
    loadData(id);
    fetchDataCountry();
    fetchCustomer({ id: parentUserId });
  }, []);

  useEffect(() => {
    if (values?.countryId) {
      if (dataStates.length) {
        if (dataStates[0].country_id !== values.countryId) {
          fetchDataStates(values.countryId);
        }
      } else {
        fetchDataStates(values.countryId);
      }
    }

    if (values?.stateId) {
      if (dataAreas.length) {
        if (dataAreas[0].state_id !== values.stateId) {
          fetchDataAreas(values.stateId);
        }
      } else {
        fetchDataAreas(values.stateId);
      }
    }
  }, [values]);

  const checkPostcodeExists = () => {
    const checkExists = getPostcodesArray().find((i) => i === values.postcode);

    if (checkExists) return values.postcode;

    return '';
  };

  const getPostcodesArray = () => {
    let postcodeStringCheck = dataAreas.filter((i) => i.id === values.areaId);

    if (postcodeStringCheck.length <= 0) return [];

    let postcodeString = postcodeStringCheck.length >= 0 ? postcodeStringCheck[0].postcode_string : '';

    let postcodeArray = postcodeString.includes(',') ? postcodeString.split(',') : [postcodeString];

    if (postcodeArray.length <= 0) return [];

    return postcodeArray;
  };

  const RenderForm = () => {
    if (!values) return <></>;

    return (
      <form onSubmit={handleSubmit}>
        {/* {JSON.stringify(values)} */}
        <StyledCard>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={6} textAlign={'left'}>
              <CommonSectionHeader
                title={`${t('mainBranchProfile')} (*)`}
                subTitle={t('mainBranchProfileDetailsInformation')}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <FormControlLabel
                control={
                  <Switch
                    name="status"
                    checked={Boolean(values.status)}
                    onChange={(event, checked) => {
                      setFieldValue('status', checked);
                    }}
                  />
                }
                label={Boolean(values.status) ? t('enabled') : t('disabled')}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} textAlign="right">
              <FormControlLabel
                control={
                  <Switch
                    name="status"
                    checked={Boolean(values.isHQ)}
                    onChange={(event, checked) => {
                      setFieldValue('isHQ', checked);
                    }}
                  />
                }
                label={Boolean(values.isHQ) ? t('mainBranch') : t('normalBranch')}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'branchName'}
                    label={t('branchName')}
                    type="text"
                    variant="outlined"
                    value={values.branchName}
                    onChange={handleChange}
                    error={touched.branchName && Boolean(errors.branchName)}
                    helperText={touched.branchName && errors.branchName}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'branchCode'}
                    label={t('branchCode')}
                    type="text"
                    variant="outlined"
                    value={values.branchCode}
                    onChange={handleChange}
                    error={touched.branchCode && Boolean(errors.branchCode)}
                    helperText={touched.branchCode && errors.branchCode}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'branchContact'}
                    label={t('branchContact')}
                    type="text"
                    variant="outlined"
                    value={values?.branchContact}
                    onChange={handleChange}
                    error={touched.branchContact && Boolean(errors.branchContact)}
                    helperText={touched.branchContact && errors.branchContact}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'branchEmail'}
                    label={t('branchEmail')}
                    type="email"
                    variant="outlined"
                    value={values.branchEmail}
                    onChange={handleChange}
                    error={Boolean(errors.branchEmail)}
                    helperText={errors.branchEmail}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'picName'}
                    label={t('contactName')}
                    type="text"
                    variant="outlined"
                    value={values.picName}
                    onChange={handleChange}
                    error={touched.picName && Boolean(errors.picName)}
                    helperText={touched.picName && errors.picName}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'picContact'}
                    label={t('contactNo')}
                    type="text"
                    variant="outlined"
                    value={values.picContact}
                    onChange={handleChange}
                    error={touched.picContact && Boolean(errors.picContact)}
                    helperText={touched.picContact && errors.picContact}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'picEmail'}
                    label={t('contactEmail')}
                    type="email"
                    variant="outlined"
                    value={values.picEmail}
                    onChange={handleChange}
                    error={touched.picEmail && Boolean(errors.picEmail)}
                    helperText={touched.picEmail && errors.picEmail}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <FormControl margin="dense" fullWidth size="small" error={touched.marking && Boolean(errors.marking)}>
                    <InputLabel id="location">Branch Marking</InputLabel>
                    <Select
                      labelId="marking"
                      label={t('branchMarking')}
                      name={'marking'}
                      onChange={(event) => {
                        setFieldValue(`marking`, event.target.value);
                      }}
                      value={values.marking ? values.marking : ''}
                    >
                      {dataMarkings?.map((i, index) => {
                        return (
                          <MenuItem key={index} value={i.value}>
                            {i.display}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>{touched.marking && errors.marking}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'remark'}
                    label={t('remark')}
                    type="text"
                    multiline
                    rows={3}
                    variant="outlined"
                    value={values.remark}
                    onChange={handleChange}
                    error={touched.remark && Boolean(errors.remark)}
                    helperText={touched.remark && errors.remark}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>

            <Grid item xs={12} sm={12} md={6} textAlign={'left'}>
              <CommonSectionHeader title={t('mainBranchAddress')} subTitle={t('mainBranchAddressDetailsinformation')} />
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <FormControl margin="dense" fullWidth size="small" error={touched.type && Boolean(errors.type)}>
                <InputLabel id="type">{t('branchType')}</InputLabel>
                <Select
                  disabled
                  labelId="type"
                  label={t('branchType')}
                  name={'type'}
                  // onChange={
                  //     (event) =>{
                  //         setFieldValue("type",event.target.value)
                  //     }
                  // }
                  value={values.type}
                >
                  {branchDataTypes.map((i, index) => {
                    return (
                      <MenuItem key={index} value={i.id}>
                        {i.display}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>{touched.type && errors.type}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid container spacing={1}>
                {/* <Grid item xs={12} sm={12} md={6}>
                                    <></>
                                </Grid> */}

                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'address1'}
                    label={t('address1')}
                    type="text"
                    variant="outlined"
                    value={values.address1}
                    onChange={handleChange}
                    error={touched.address1 && Boolean(errors.address1)}
                    helperText={touched.address1 && errors.address1}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={'address2'}
                    label={t('address2')}
                    type="text"
                    variant="outlined"
                    value={values.address2}
                    onChange={handleChange}
                    error={touched.address2 && Boolean(errors.address2)}
                    helperText={touched.address2 && errors.address2}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={touched.countryId && Boolean(errors.countryId)}
                  >
                    <InputLabel id="country">{t('country')}</InputLabel>
                    <Select
                      labelId="countryId"
                      label={t('country')}
                      name={'countryId'}
                      onChange={(event) => {
                        setFieldValue(`countryId`, event.target.value);
                        setFieldValue(`stateId`, '');
                        setFieldValue(`areaId`, '');
                        setDataStates([]);
                        setDataAreas([]);
                      }}
                      value={checkValueExists({
                        dataSearch: dataCountries,
                        valueToCompare: values.countryId,
                      })}
                    >
                      {dataCountries.map((i, index) => {
                        return (
                          <MenuItem key={index} value={i.id}>
                            {i.country_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>{touched.countryId && errors.countryId}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <FormControl margin="dense" fullWidth size="small" error={touched.stateId && Boolean(errors.stateId)}>
                    <InputLabel id="state">{t('state')}</InputLabel>
                    <Select
                      labelId="stateId"
                      label={t('state')}
                      name={'stateId'}
                      onChange={(event) => {
                        setFieldValue(`stateId`, event.target.value);
                        setFieldValue(`areaId`, '');
                        setDataAreas([]);
                      }}
                      value={checkValueExists({
                        dataSearch: dataStates,
                        valueToCompare: values.stateId,
                      })}
                    >
                      {dataStates.map((i, index) => {
                        return (
                          <MenuItem key={index} value={i.id}>
                            {i.state_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>{touched.stateId && errors.stateId}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <FormControl margin="dense" fullWidth size="small" error={touched.areaId && Boolean(errors.areaId)}>
                    <InputLabel id="area">{t('area')}</InputLabel>
                    <Select
                      labelId="areaId"
                      label={t('area')}
                      name={'areaId'}
                      onChange={(event) => {
                        setFieldValue(`areaId`, event.target.value);
                        setFieldValue(`postcode`, '');
                      }}
                      value={checkValueExists({
                        dataSearch: dataAreas,
                        valueToCompare: values.areaId,
                      })}
                    >
                      {dataAreas.map((i, index) => {
                        return (
                          <MenuItem key={index} value={i.id}>
                            {i.area_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>{touched.areaId && errors.areaId}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={touched.postcode && Boolean(errors.postcode)}
                  >
                    <InputLabel id="postcode">{t('postcode')}</InputLabel>
                    <Select
                      labelId="postcode"
                      label={t('postcode')}
                      name={'postcode'}
                      onChange={handleChange}
                      value={
                        // values.postcode
                        checkPostcodeExists()
                      }
                    >
                      {getPostcodesArray().length ? (
                        getPostcodesArray().map((i, index) => {
                          return (
                            <MenuItem key={index} value={i}>
                              {i}
                            </MenuItem>
                          );
                        })
                      ) : (
                        <MenuItem value={''}>{null}</MenuItem>
                      )}
                    </Select>
                    <FormHelperText>{touched.postcode && errors.postcode}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </StyledCard>

        <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
          <Grid item md={12} textAlign={'right'}>
            <Button
              type="submit"
              // fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
              }}
              disabled
            >
              {t('saveChanges')}
            </Button>
          </Grid>
        </Grid>

        <Divider sx={{ my: 1 }} />

        <Grid container spacing={1} sx={{ pl: 2, pr: 2, pb: 2 }}>
          <Grid item md={12} textAlign={'left'}>
            <Typography
              sx={{
                color: grey[500],
                fontSize: 11,
              }}
            >
              {`${markingInjectionProps.marking.retrieveKey} : ${values?.injectionProps[markingInjectionProps.marking.retrieveKey]
                }`}
            </Typography>

            <Typography
              sx={{
                color: grey[500],
                fontSize: 11,
              }}
            >
              {`${markingInjectionProps.postcode.retrieveKey} : ${values?.injectionProps[markingInjectionProps.postcode.retrieveKey]
                }`}
            </Typography>

            <Typography
              sx={{
                color: grey[500],
                fontSize: 11,
              }}
            >
              {`${markingInjectionProps.sourceMarkingRemId.retrieveKey} : ${values?.injectionProps[markingInjectionProps.sourceMarkingRemId.retrieveKey]
                }`}
            </Typography>
          </Grid>
        </Grid>
      </form>
    );
  };

  return (
    <Box>
      {isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ? RenderForm() : <CommonRestricted />}

      {/* <Typography
                sx={{
                    fontSize: 13
                }}
            >
                {JSON.stringify(values?.injectionProps)}
            </Typography> */}
    </Box>
  );
}
